module.exports = __webpack_public_path__ + "img/img-intersection@2x.ae549b4d.png";